import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const ExtraPlacesIcon = observer(
    'ExtraPlacesIcon',
    ({ className, onClick }: SvgIconPropsType): JSX.Element => (
        <SvgIcon
            className={className}
            onClick={onClick}
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.3317 13.3337C13.3317 13.7003 13.2012 14.0142 12.94 14.2753C12.6789 14.5364 12.365 14.667 11.9984 14.667L9.74837 14.667C9.62615 14.667 9.5206 14.6281 9.43171 14.5503C9.34282 14.4725 9.28726 14.3725 9.26504 14.2503C9.17615 13.9837 9.01504 13.7642 8.78171 13.592C8.54837 13.4198 8.28726 13.3337 7.99837 13.3337C7.70948 13.3337 7.44837 13.4198 7.21504 13.592C6.98171 13.7642 6.82059 13.9837 6.73171 14.2503C6.70948 14.3725 6.65393 14.4725 6.56504 14.5503C6.47615 14.6281 6.37059 14.667 6.24837 14.667L3.99837 14.667C3.63171 14.667 3.31782 14.5364 3.05671 14.2753C2.79559 14.0142 2.66504 13.7003 2.66504 13.3337L2.66504 2.66699C2.66504 2.30033 2.79559 1.98644 3.05671 1.72533C3.31782 1.46422 3.63171 1.33366 3.99837 1.33366L6.24837 1.33366C6.37059 1.33366 6.47615 1.37255 6.56504 1.45033C6.65393 1.5281 6.70948 1.6281 6.73171 1.75033C6.82059 2.01699 6.98171 2.23644 7.21504 2.40866C7.44837 2.58088 7.70948 2.66699 7.99837 2.66699C8.28726 2.66699 8.54837 2.58088 8.78171 2.40866C9.01504 2.23644 9.17615 2.01699 9.26504 1.75033C9.28726 1.6281 9.34282 1.5281 9.43171 1.45033C9.5206 1.37255 9.62615 1.33366 9.74837 1.33366L11.9984 1.33366C12.365 1.33366 12.6789 1.46422 12.94 1.72533C13.2012 1.98644 13.3317 2.30033 13.3317 2.66699L13.3317 13.3337Z'
                fill='black'
            />
            <path
                d='M10 10.6663H6V5.33301H10V6.25959H7.47268V7.43059H9.82423V8.35718H7.47268V9.73246H10V10.6663Z'
                fill='white'
            />
        </SvgIcon>
    )
);
